<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-tachometer"></i> RBC Completion Dashboard</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Manpower Requisition</button> -->
                </div>
            </div>
            <!--end header-->

       <!--Payroll Dashboard Cycle  -->
            <div class="row row-replace m-t-10 menu-column border border-rad">
                <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                   <i class="fa fa-link"></i> RBS Completion Dashboard-(Region Wise)
                </div>
                <div class="col-12 col-pn">
                   <div class="table-responsive">
                      <table class="table table-align">
                         <thead>
                           <th>Regions</th>
                           <th>Total Active Employees	</th>
                           <th>RBC Trained Employees</th>
                           <th>Pending Employee Count</th>
                           <th>Completion %</th>
                         </thead>
                         <tr>
                             <td colspan="5" class="text-danger" style="text-align: left !important;">
                                Top 3	Regions	
                             </td>
                         </tr>
                         <tbody>
                            <tr>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                            </tr>
                         </tbody>
                         <tr>
                            <td colspan="5" class="text-danger" style="text-align: left !important;">
                               Buttom	Regions	
                            </td>
                        </tr>
                        <tbody>
                           <tr>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                           </tr>
                        </tbody>
                      </table>
                   </div>
                </div>
             </div>
        

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

